<template>
    <div class="aboutPage" ref="aboutPage">
        <div class="aboutDescWrapper">
            <h2 class="aboutTitle animated">{{ $t('about.title') }}</h2>
            <p class="text animated" v-html="$t('about.text1')"></p>
            <p class="text animated" v-html="$t('about.text2')"></p>
            <p class="text animated"><span v-html="$t('about.text3')"></span><br/><span v-html="$t('about.text4')"></span></p>
            <p class="text animated">
                {{ $t('about.text5') }} <a v-if="this.$i18n.locale() == 'fr'" :href="require('../../assets/cv_rousseau_kevin_fr.pdf')" class="bold" target="_blank">{{ $t('about.text6') }}</a>
                <a v-else :href="require('../../assets/resume_rousseau_kevin_en.pdf')" class="bold" target="_blank">{{ $t('about.text6') }}</a>.
            </p>

            <ul class="linksList">
                <li class="animated"><a href="mailto:hello|%/+at%$|kevinrousseau.com" class="mail icon-envelope" @click="cleanMail"></a></li>
                <li class="animated"><a href="https://www.linkedin.com/in/kévin-rousseau-20983381/" target="_blank" class="icon-linkedin"></a></li>
                <li class="animated"><a href="https://github.com/kevrou" target="_blank" class="icon-github"></a></li>
                <li class="animated"><a href="https://twitter.com/kevRousseau" target="_blank" class="icon-twitter"></a></li>
            </ul>
        </div>
    </div>
</template>

<script>
import {TweenMax} from 'gsap'

export default {
    name: 'About',
    data () {
        return {

        }
    },
    mounted: function(){
        TweenMax.staggerTo(this.$refs.aboutPage.querySelectorAll('.animated'), 0.5, {opacity: 1, y: 0}, 0.08)
    },
    methods: {
        cleanMail: function(e){
            let target = e.currentTarget,
                url = target.getAttribute('href'),
                newUrl = url.replace('|%/+at%$|', '@')

            target.setAttribute('href', newUrl)
        }
    },
    beforeRouteLeave (to, from, next) {
       TweenMax.staggerTo(this.$refs.aboutPage.querySelectorAll('.animated'), 0.5, {opacity: 0, y: -100}, 0.08, next)
    }
}
</script>

<style lang="scss">
    @import './about';
</style>



// WEBPACK FOOTER //
// src/components/About/About.vue